import Header from "../Header";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import "../GuestMode/GuestMode.scss";

const RequestClubSkeleton = () => {
  return (
    <>
      <Header />
      <div className="centerGroup" data-testid="request-club-skeleton">
        <div className="desktopUI">
          <div className="row userProfile_Header">
            <Breadcrumbs />
          </div>

          <div className="sClubs mt-3 d-flex align-items-center w-100">
            <p className="d-flex align-items-center">Requested Clubs</p>
          </div>

          <div className="align-content-center justify-content-start d-flex col">
            <p className="yellowTxt m-2">
              <span className="loading-effect loading-effect-text loading-effect-text-lg" />
            </p>
          </div>

          {Array.from({ length: 5 }, (_, index) => (
            <div className="clubCon" key={`request-club-listing-skeleton-${index}`}>
              <div className="form-check m-3 align-items-center col d-flex">
                <div
                  className="loading-effect"
                  style={{
                    width: "16px",
                    height: "16px",
                    borderRadius: "4px",
                    marginRight: "12px",
                  }}
                />
                <div
                  className="loading-effect"
                  style={{
                    width: "50px",
                    height: "35px",
                    marginRight: "12px",
                  }}
                />
                <div className="align-content-center col d-flex">
                  <div className="loading-effect loading-effect-text loading-effect-text-lg" />
                </div>
              </div>
            </div>
          ))}

          <div className="mb-5" />
        </div>
      </div>
    </>
  );
};

export default RequestClubSkeleton;
